export const QuotationCategoriesService = () => {};

const defaultCategories = [
    'Academias de ginástica - manutenção de equipamentos',
    'Adequação elétrica à norma NBR 5419',
    'Alambrados - instalação ou manutenção',
    'Alarmes contra incêndio',
    'Antenas coletivas - instalação ou manutenção',
    'Análise de água - Laudo de potabilidade',
    'Aquecimento central - instalação ou manutenção',
    'Aquecimento de piscinas - instalação ou manutenção',
    'Aquecimento solar - instalação ou manutenção',
    'Ar-condicionado central - instalação ou manutenção',
    'Ar-condicionado não central - instalação ou manutenção',
    'ASO - admissional ou demissional',
    'Assessoria fiscal e tributária',
    'Assessoria jurídica em geral',
    'Auto de Vistoria do Corpo de Bombeiros (AVCB)',
    'Autovistoria Predial',
    'Ações trabalhistas',
    'Bicicletários - instalação ou manutenção',
    'Bombas - instalação ou manutenção',
    'Bombas de água - instalação ou manutenção',
    'Box de vidro para banheiros',
    'Cabeamento estruturado',
    'Calhas e rufos - instalação ou manutenção',
    'Cerca elétrica',
    'Cercas e grades - serralheria',
    'Coberturas de metal',
    'Coberturas',
    'Cobrança extrajudicial',
    'Cobrança judicial',
    'Concertinas - instalação ou manutenção',
    'Construção de novos comodos/ambientes',
    'Consultoria contábil',
    'Consultoria e projetos de segurança eletrônica',
    'Controle de acesso',
    'Controle de pragas (dedetização)',
    'Corrimãos e guarda-corpos',
    'Decks de madeira',
    'Demolição',
    'Desentupidora',
    'Detecção de vazamento de gás',
    'Detecção de vazamentos de água',
    'Direito Imobiliário',
    'Drywall',
    'Elaboração de convenção de condomínio',
    'Elevadores - instalação novo elevador',
    'Elevadores - manutenção',
    'Elevadores - reforma / modernização',
    'Equipamentos de proteção individual (EPIs)',
    'Escadas e rampas de acesso - construção ou reforma',
    'Espelhos sob medida',
    'Extintores e equipamentos - manutenção ou compra',
    'Fachadas - pintura, restauração ou reforma',
    'Fechamento de varandas com vidro',
    'Fiscalização de obras e projetos',
    'Fornecimentos de árvores e mudas',
    'Galpões - construção ou reforma',
    'Geradores - instalação ou manutenção',
    'Gerenciamento de obras e projetos',
    'Gesso e forros',
    'Gestão de leitura de instalações de gás individualizadas',
    'Gestão de leitura de instalações hidráulicas individualizadas',
    'Glazing - vidros',
    'Grama sintética',
    'Grelhas e ralos - serralheria',
    'Impermeabilização de caixas de água e reservatórios',
    'Impermeabilização de lajes',
    'Impermeabilização de paredes e fachadas',
    'Impermeabilização de piscina',
    'Impermeabilização de telhados',
    'Impermeabilização de áreas molhadas (banheiros, cozinhas, varandas, etc...)',
    'Impermeabilização em geral',
    'Individualização de gás',
    'Individualização de água',
    'Instalação de revestimentos em piso',
    'Instalação ou manuntenção de rede de incêndio',
    'Instalações de gás - construção ou reforma',
    'Instalações elétrica - construção ou reforma',
    'Instalações hidráulica  - construção ou reforma',
    'Isolamento acústico',
    'Janelas acústicas',
    'Janelas blindadas',
    'Janelas de madeira',
    'Janelas de metal',
    'Janelas de PVC',
    'Lapidação e polimento de piso',
    'Laudos e inspeções de para-raios (SPDA)',
    'Laudos e vistoria de instalações de gás',
    'Laudos e vistoria de instlações elétricas',
    'Laudos, vistorias e perícias técnicas de estruturas',
    'Limpeza de caixas de água e reservatórios',
    'Limpeza de fachadas',
    'Limpeza de fossa séptica',
    'Limpeza de pisos e superfícies',
    'Limpeza pós-eventos',
    'Limpeza pós-obra',
    'LTCAT – Laudo Técnico das Condições Ambientais de Trabalho',
    'Marcenaria - outros',
    'Modernização de PC de luz',
    'Muros - construção ou reforma',
    'Mármore e granito - bancadas e peças sob medida',
    'Mármore e granito - pisos e revestimentos',
    'Móveis de madeira sob medida',
    'Outro',
    'Pavimentação asfáltica',
    'PCMSO, PPRA, PCMAT, PPP, PCA',
    'PDA - Adequação à NBR 5419',
    'Pedras naturais e sintéticas',
    'Pele de vidro / fachada de vidro - construção',
    'Pele de vidro / fachada de vidro - manutenção',
    'Películas (insulfilm)',
    'Períto judicial',
    'Pintura de ambientes externos',
    'Pintura de ambientes internos',
    'Pintura de garagens',
    'Piscinas - construção ou reforma',
    'Piscinas - manutenção ou limpeza',
    'Piso epoxy ou poliuretano',
    'Pisos intertravados',
    'Plantio e replantio',
    'Playgrounds - manutenção de brinquedos / equipamentos',
    'Poda e supressão de árvores',
    'Portaria remota (eletrônica/virtual)',
    'Portas acústicas',
    'Portas blindadas',
    'Portas corta-fogo - instalação ou manutenção',
    'Portas de vidro',
    'Portas e esquadrias de madeira',
    'Portas e esquadrias de metal',
    'Portas e esquadrias de PVC',
    'Portões automáticos',
    'Portões convencionais',
    'Poços artesianos',
    'Projeto arquitetonico',
    'Projeto de acessibilidade',
    'Projeto de design de interiores e decoração',
    'Projeto de economia de energia',
    'Projeto de economia de água',
    'Projeto de estrutura metálica',
    'Projeto de iluminação',
    'Projeto de instalações de gás',
    'Projeto de instalações elétricas',
    'Projeto de instalações hidráulicas',
    'Projeto de isolamento acústico',
    'Projeto de isolamento térmico',
    'Projeto de paisagismo',
    'Projeto de retrofit',
    'Projeto de TI e dados',
    'Projeto estrutural',
    'Projetos combate à incêndio e pânico',
    'Projetos de economia de energia',
    'Projetos de economia de água',
    'Quadras de esportes - construção',
    'Quadras de esportes - pintura',
    'Quadras de esportes - restauração ou manutenção de piso',
    'Rampas metálicas de acesso - serralheria',
    'Recuperação / conserto de áreas impermeabilizadas',
    'Recuperação estrutural',
    'Reforma de comodos/ambientes',
    'Restauração e tratamento de pisos',
    'Retrofit e reformas completas',
    'Saunas - construção ou reforma',
    'Saunas - instalação ou manutenção',
    'Sensores e alarmes - instalação ou manutenção',
    'Serralheria - outros',
    'Sistemas CFTV - instalação ou manutenção',
    'Sistemas de coleta e reuso de água',
    'Sistemas de energia solar - instalação ou manutenção',
    'Sistemas de irrigação - instalação ou manutenção',
    'SPDA / Para-raios - instalação ou manutenção',
    'Síndicos profissionais',
    'Tampões',
    'Telhado - construção ou manutenção',
    'Telhado verde',
    'Telhados - construção ou manutenção',
    'Terceirização de auxiliar serviços gerais',
    'Terceirização de guardião de piscina',
    'Terceirização de Jardinagem',
    'Terceirização de limpeza',
    'Terceirização de portaria',
    'Terceirização de professores de Educação Física',
    'Terceirização de segurança (vigilante não armado)',
    'Terceirização de vigilante armado',
    'Terceirização de zeladoria',
    'Toldos e sombreadores - instalação ou manutenção',
    'Treinamento de brigada de incêndio',
    'Troca de barrilete hidráulico',
    'Venezianas',
    'Vidraçaria - outros',
    'Vidros blindados',
    'Vidros sob medida'
];

const testingCategories = [
    'Academias de ginástica - manutenção de equipamentos',
    'Adequação elétrica à norma NBR 5419',
    'Alambrados - instalação ou manutenção',
    'Alarmes contra incêndio',
    'Antenas coletivas - instalação ou manutenção'
];

export const getQuotationCategories = (administrator = '') => {
    switch (administrator.toLowerCase()) {
    case 'Engelink'.toLowerCase():
        return testingCategories;
    default:
        return defaultCategories;
    }
};
